import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CRow,
  CButton,
  CSpinner,
  CAlert,
} from '@coreui/react';
import useResetPasswordViewModel from '../viewmodels/ResetPasswordViewModel';
import { PasswordInputGroup } from '../components/InputGroup';

const ResetPasswordView = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [validationError, setValidationError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { resetPassword, loading, error, success } = useResetPasswordViewModel();

  // Get reset token from URL params
  const resetToken = new URLSearchParams(location.search).get('reset_token');

  useEffect(() => {
    if (!resetToken) {
      navigate('/login');
    }
  }, [resetToken, navigate]);

  const validatePasswords = () => {
    if (password.length === 0) {
      setValidationError('Password is required');
      return false;
    }
    if (password !== confirmPassword) {
      setValidationError('Passwords do not match');
      return false;
    }
    setValidationError('');
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validatePasswords()) return;

    const success = await resetPassword(resetToken, password);
    if (success) {
      // Wait a moment to show the success message before redirecting
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    }
  };

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={8}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm onSubmit={handleSubmit}>
                    <h1>Reset Password</h1>
                    <p className="text-medium-emphasis">Enter your new password</p>
                    {error && <CAlert color="danger">{error}</CAlert>}
                    {validationError && (
                      <CAlert color="danger">{validationError}</CAlert>
                    )}
                    {success && (
                      <CAlert color="success">
                        Password reset successful! Redirecting to login...
                      </CAlert>
                    )}

                    <PasswordInputGroup
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="New Password"
                      autoComplete="new-password"
                      disabled={loading || success}
                      required
                    />

                    <PasswordInputGroup
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Confirm New Password"
                      autoComplete="new-password"
                      className="mb-4"
                      disabled={loading || success}
                      required
                    />

                    <CRow>
                      <CCol xs={6}>
                        <CButton
                          type="submit"
                          color="primary"
                          className="px-4"
                          disabled={loading || success}
                        >
                          {loading ? <CSpinner size="sm" /> : 'Reset Password'}
                        </CButton>
                      </CCol>
                      <CCol xs={6} className="text-right">
                        <CButton
                          color="link"
                          className="px-0"
                          onClick={() => navigate('/login')}
                        >
                          Back to Login
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default ResetPasswordView;